import React from 'react';
import { Route } from 'react-router-dom'

import Menu from './components/menu';
import LevelComplete from './components/levelcomplete';
import GameMode from './components/gamemode';
import LandingPage from './components/landingpage';
import Ppo from './components/ppo';

const Routes = (
	<div>
      <Route exact path="/" component={LandingPage} />
      <Route path="/games/:level/:review?" component={GameMode} />
      <Route path="/menu/" component={Menu} />
      <Route path="/ppo/" component={Ppo} />
      <Route path="/levelcomplete/:level" component={LevelComplete} />
  	</div>
)


export default Routes;



// WEBPACK FOOTER //
// ./src/routes.js